// @generated by protoc-gen-es v1.7.2
// @generated from file tendermint/types/evidence.proto (package tendermint.types, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { LightBlock, Vote } from "./types_pb.js";
import { Validator } from "./validator_pb.js";

/**
 * @generated from message tendermint.types.Evidence
 */
export const Evidence = proto3.makeMessageType(
  "tendermint.types.Evidence",
  () => [
    { no: 1, name: "duplicate_vote_evidence", kind: "message", T: DuplicateVoteEvidence, oneof: "sum" },
    { no: 2, name: "light_client_attack_evidence", kind: "message", T: LightClientAttackEvidence, oneof: "sum" },
  ],
);

/**
 * DuplicateVoteEvidence contains evidence of a validator signed two conflicting votes.
 *
 * @generated from message tendermint.types.DuplicateVoteEvidence
 */
export const DuplicateVoteEvidence = proto3.makeMessageType(
  "tendermint.types.DuplicateVoteEvidence",
  () => [
    { no: 1, name: "vote_a", kind: "message", T: Vote },
    { no: 2, name: "vote_b", kind: "message", T: Vote },
    { no: 3, name: "total_voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "validator_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * LightClientAttackEvidence contains evidence of a set of validators attempting to mislead a light client.
 *
 * @generated from message tendermint.types.LightClientAttackEvidence
 */
export const LightClientAttackEvidence = proto3.makeMessageType(
  "tendermint.types.LightClientAttackEvidence",
  () => [
    { no: 1, name: "conflicting_block", kind: "message", T: LightBlock },
    { no: 2, name: "common_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "byzantine_validators", kind: "message", T: Validator, repeated: true },
    { no: 4, name: "total_voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message tendermint.types.EvidenceList
 */
export const EvidenceList = proto3.makeMessageType(
  "tendermint.types.EvidenceList",
  () => [
    { no: 1, name: "evidence", kind: "message", T: Evidence, repeated: true },
  ],
);

